import _get from "lodash/get";
import { readProductShoppingActions } from "../actions";
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case readProductShoppingActions.SUCCESS_TYPE:
      return _get(payload, 'items');

    default:
      return state;
  }
});